<template>
  <div class="flex justify-between items-center">
    <BaseHeader :content="header"/>
    <div class="cq-container w-full flex gap-2 justify-end mx-4">
      <template v-if="showPeriodPicker">
        <div class="flex bg-primary-50 dark:bg-darkblue rounded-lg p-1 text-xs" :class="layoutClasses.periodDesktop">
          <base-button v-for="period in activePeriods" :key="period.id" mode="primary-phantom" 
            class="mr-1 min-w-40 whitespace-nowrap" :class="{ active: activePeriod === period.id }"
            :text="period.name" size="xs" :disabled="disableSelect" @click="toggleActivePeriod(period.id)" />
        </div>
        <div ref="periodDropdown" v-outside:click="{ exclude: ['periodDropdown'], handler: closePeriodDropdown }" class="relative w-auto min-w-30 !bg-primary-50 !dark:bg-darkblue rounded-lg p-1" :class="layoutClasses.periodLaptop">
          <base-button mode="primary-phantom" size="xs" :disabled="disableSelect" @click="togglePeriodDropdown"
            class="w-full justify-between px-3">
            <span class="flex items-center justify-between w-full">
              <span class="w-full">{{ activePeriodName }}</span>
              <base-icon name="chevrondown" size="sm" class="ml-2" />
            </span>
          </base-button>
          <base-drop-down :isOpen="showPeriodDropdown" position="top-left"
            customClass="w-full p-1 !bg-primary-50 dark:!bg-darkblue border-primary-100 z-2010"
            @toggle="closePeriodDropdown">
            <div class="flex flex-col gap-1">
              <base-button v-for="period in activePeriods" :key="`mobile-${period.id}`" mode="primary-phantom"
                class="w-full justify-start whitespace-nowrap" :class="{ active: activePeriod === period.id }"
                :text="period.name" size="xs" :disabled="disableSelect" @click="closePeriodDropdown(); toggleActivePeriod(period.id)" />
            </div>
          </base-drop-down>
        </div>
      </template>
      <!-- <accessible-date-picker class="bg-white dark:bg-darkblue-900" v-model="valueDate" type="date" :picker-options="{initialView: 'month'}" /> -->
      <!-- <accessible-date-picker-2 class="bg-white dark:bg-darkblue-900" v-model="valueDate" type="date" /> -->
      <!-- <el-date-picker class="bg-white dark:bg-darkblue-900"
        v-model="valueDate"
        type="daterange"
        :picker-options="dateRangeOptions"
        :disabled="disableSelect" /> -->
      <div v-if="showDatePicker" class="block" :class="layoutClasses.dateDesktop">
        <el-date-picker v-if="activePeriod !== 'trimestre'" class="bg-white dark:bg-darkblue-900"
          :value="valueDate"
          :type="typeDate"
          :format="formatDate"
          :value-format="formatValueDate"
          :picker-options="dateRangeOptions"
          :disabled="disableSelect"
          :clearable="false"
          @input="updateValueDate" />
        <quarter-picker v-else 
          class="bg-white dark:bg-darkblue-900"
          :value="valueDate" 
          :format="formatDate" 
          :value-format="formatValueDate"
          :disabled="disableSelect"
          :disabled-date="dateRangeOptions.disabledDate"
          :loading="loadingQuarters"
          :clearable="false"
          @input="updateValueDate" />
      </div>
      <accessible-el-select v-if="showCifEmpresaPicker"
        class="block"
        :class="layoutClasses.cifDesktop"
        prop="cifEmpresa"
        value-key="IdCIFEmpresa"
        :value="cifEmpresa"
        :options="cifEmpresaOptions"
        :disabled="disableSelect"
        :with-form-item="false"
        :clearable="false"
        filterable
        @input="updateCifEmpresa"
      />
      <div class="flex gap-2" :class="layoutClasses.actionsDesktop">
        <base-button-icon @click="printFinancialDashboard" name="printer" :disabled="disableSelect"/>
        <base-button-icon @click="refreshPage" name="refresh" :disabled="disableSelect" icon-size="sm"/>
      </div>
      <div id="myoptionsflag" ref="options"
        v-outside:click="{ exclude: ['options', collapsedPickerElement, 'collapsedQuarterPicker', 'cifEmpresaLaptopPicker'], handler: closeOptions }"
        class="dropdown-area"
        :class="layoutClasses.optionsMenu">
        <base-button-icon name="hamburguer" @click="toggleOptions" />
        <div class="relative">
          <base-drop-down
            :isOpen="showOptions"
            position="bottom-right"
            @toggle="toggleOptions">
            <ul class="p-1 divide-y divide-gray-50 dark:divide-gray-800 dark:border-darkblue-600">
              <li v-if="showPeriodPicker" ref="periodDropdownMobile" v-outside:click="{ exclude: ['periodDropdownMobile'], handler: closePeriodDropdownMobile }" class="relative w-auto min-w-30 !bg-primary-50 !dark:bg-darkblue rounded-lg p-1" :class="layoutClasses.periodMobile">
                <base-button mode="primary-phantom" size="xs" :disabled="disableSelect" @click="togglePeriodDropdownMobile"
                  class="w-full justify-between px-3">
                  <span class="flex items-center justify-between w-full">
                    <span class="w-full">{{ activePeriodName }}</span>
                    <base-icon name="chevrondown" size="sm" class="ml-2" />
                  </span>
                </base-button>
                <base-drop-down :isOpen="showPeriodDropdownMobile" position="top-left"
                  customClass="w-full p-1 !bg-primary-50 dark:!bg-darkblue border-primary-100 z-2010"
                  @toggle="closePeriodDropdownMobile">
                  <div class="flex flex-col gap-1">
                    <base-button v-for="period in activePeriods" :key="`mobile-${period.id}`" mode="primary-phantom"
                      class="w-full justify-start whitespace-nowrap" :class="{ active: activePeriod === period.id }"
                      :text="period.name" size="xs" :disabled="disableSelect" @click="closePeriodDropdownMobile(); closeOptions(); toggleActivePeriod(period.id)" />
                  </div>
                </base-drop-down>
              </li>
              <li v-if="showDatePicker" :class="layoutClasses.dateLaptop">
                <!-- :append-to-body="false" -->
                <el-date-picker v-if="activePeriod !== 'trimestre'" class="bg-white dark:bg-darkblue-900"
                  ref="collapsedDatePicker"
                  popper-class="collapsed-date-picker-option"
                  prop="valueDate"
                  :value="valueDate"
                  :type="typeDate"
                  :format="formatDate"
                  :value-format="formatValueDate"
                  :picker-options="dateRangeOptions"
                  :disabled="disableSelect"
                  :clearable="false"
                  @input="updateValueDate"
                  @focus="updateDatePickerElement"
                  @change="closeOptions"
                />
                <quarter-picker v-else 
                  class="bg-white dark:bg-darkblue-900" 
                  :value="valueDate" 
                  :format="formatDate" 
                  :value-format="formatValueDate"
                  ref="collapsedQuarterPicker"
                  popper-class="collapsed-quarter-picker-option"
                  :disabled="disableSelect" :disabled-date="dateRangeOptions.disabledDate"
                  :clearable="false"
                  :loading="loadingQuarters"
                  @input="updateValueDate" />
              </li>
              <li v-if="showCifEmpresaPicker" :class="layoutClasses.cifLaptop">
                <accessible-el-select
                  ref="cifEmpresaLaptopPicker"
                  popper-class="collapsed-cif-empresa-picker-option"
                  prop="cifEmpresa"
                  value-key="IdCIFEmpresa"
                  :value="cifEmpresa"
                  :options="cifEmpresaOptions"
                  :disabled="disableSelect"
                  :with-form-item="false"
                  :clearable="false"
                  filterable
                  @input="updateCifEmpresa"
                  @focus="updateCifEmpresaPickerElement"
                  @change="closeOptions"
                />
              </li>
              <div :class="layoutClasses.actionsMenu">
                <base-link-item-nav :option="{ icon: 'printer', name: $t('app.icons.print'), click: printFinancialDashboardFromMenu, disabled: disableSelect }" />
                <base-link-item-nav :option="{ icon: 'refresh', name: $t('app.icons.refresh'), click: refreshPageFromMenu, disabled: disableSelect }" />
              </div>
            </ul>
          </base-drop-down>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment'
import { i18n } from '@/i18n'
    
import AccessibleElSelect from '@/components/elementui/AccessibleElSelect.vue'
// import AccessibleDatePicker from '@/components/date-picker'
import QuarterPicker from '@/components/QuarterPicker.vue'
    
import { getAllCompanies } from '@/services/companies/getAllCompanies'

export default {
  name: 'base-header-financial-dashboard',
  components: {
    AccessibleElSelect,
    // AccessibleDatePicker
    QuarterPicker
  },
  props: {
    title: {
      type: String,
      default: i18n.t('financial_dashboard.general_panel')
    },
    showPeriodPicker: {
      type: Boolean,
      default: true
    },
    showDatePicker: {
      type: Boolean,
      default: true
    },
    showCifEmpresaPicker: {
      type: Boolean,
      default: true
    }
  },
  data () {
    return {
      cifEmpresaList: [],
      collapsedPickerElement: null,
      collapsedQuarterPickerElement: null,
      collapsedCifEmpresaPickerElement: null,
      showPeriodDropdownMobile: false,
      showPeriodDropdown: false,
      showOptions: false,
      dateRangeOptions: {
        firstDayOfWeek: 1,
        disabledDate: (date) => moment(date).isAfter(moment(), this.currentFormat.momentType)
      },
      quarterScrollListener: null,
      quarterDropdownScrollElement: null,
      loadingQuarters: false,
      quarterOptions: []
    }
  },
  computed: {
    id () {
      return this.$route.params.id
    },
    clientId () {
      return this.$store.getters['dashboard/getSelectedClient'] || null
    },
    activePeriod () {
      return this.$store.getters['financialdashboard/activePeriod']
    },
    cifEmpresa () {
      return this.$store.getters['financialdashboard/cifEmpresa']
    },
    valueDate () {
      return this.$store.getters['financialdashboard/valueDate']
    },
    activePeriodName () {
      const period = this.activePeriods.find(period => period.id === this.activePeriod)
      return period.name ?? ''
    },
    currentFormat () {
      return this.$store.getters['financialdashboard/currentFormat']
    },
    disableSelect () {
      return !this.cifEmpresa || this.isGeneralLoading 
    },
    header () {
      const header= {
        icon: 'docblack',
        title: this.title,
        url: 'dashboard',
        params: { id: this.id }
      }
      return header
    },
    isGeneralLoading: function () {
      return this.$store.getters.isLoading
    },
    visibilityKey () {
      return `${Number(this.showPeriodPicker)}${Number(this.showDatePicker)}${Number(this.showCifEmpresaPicker)}`
    },
    layoutClasses () {
      const base = {
        periodDesktop: 'hidden',
        periodLaptop: 'hidden',
        periodMobile: 'hidden',
        dateDesktop: 'hidden',
        dateLaptop: 'hidden',
        cifDesktop: 'hidden',
        cifLaptop: 'hidden',
        actionsDesktop: 'hidden',
        actionsMenu: 'hidden',
        optionsMenu: 'hidden'
      }

      // Scaffolding per visibility combination.
      // Tune these cq-* values as needed without touching template structure.
      const byVisibility = {
        '001': {
          cifDesktop: 'hidden cq-6xs:block',
          cifLaptop: 'cq-6xs:hidden',
          actionsDesktop: 'hidden cq-2xs:flex',
          actionsMenu: 'cq-2xs:hidden',
          optionsMenu: 'cq-2xs:hidden'
        },
        '010': {
          dateDesktop: 'hidden cq-5xs:block',
          dateLaptop: 'cq-5xs:hidden',
          actionsDesktop: 'hidden cq-2xs:flex',
          actionsMenu: 'cq-2xs:hidden',
          optionsMenu: 'cq-2xs:hidden'
        },
        '011': {
          dateDesktop: 'hidden cq-5xs:block',
          dateLaptop: 'cq-5xs:hidden',
          cifDesktop: 'hidden cq-sm:block',
          cifLaptop: 'cq-sm:hidden',
          actionsDesktop: 'hidden cq-md:flex',
          actionsMenu: 'cq-md:hidden',
          optionsMenu: 'cq-md:hidden'
        },
        100: {
          periodDesktop: 'hidden cq-lg:flex',
          periodLaptop: 'hidden cq-7xs:block cq-lg:hidden',
          periodMobile: 'cq-7xs:hidden',
          actionsDesktop: 'hidden cq-5xs:flex',
          actionsMenu: 'cq-5xs:hidden',
          optionsMenu: 'cq-5xs:hidden'
        },
        101: {
          periodDesktop: 'hidden cq-2xl:flex',
          periodLaptop: 'hidden cq-7xs:block cq-2xl:hidden',
          periodMobile: 'cq-7xs:hidden',
          cifDesktop: 'hidden cq-sm:block',
          cifLaptop: 'cq-sm:hidden',
          actionsDesktop: 'hidden cq-md:flex',
          actionsMenu: 'cq-md:hidden',
          optionsMenu: 'cq-md:hidden'
        },
        110: {
          periodDesktop: 'hidden cq-2xl:flex',
          periodLaptop: 'hidden cq-sm:block cq-2xl:hidden',
          periodMobile: 'cq-sm:hidden',
          dateDesktop: 'hidden cq-5xs:block',
          dateLaptop: 'cq-5xs:hidden',
          actionsDesktop: 'hidden cq-md:flex',
          actionsMenu: 'cq-md:hidden',
          optionsMenu: 'cq-md:hidden'
        },
        111: {
          periodDesktop: 'hidden cq-4xl:flex',
          periodLaptop: 'hidden cq-sm:block cq-4xl:hidden',
          periodMobile: 'cq-sm:hidden',
          dateDesktop: 'hidden cq-5xs:block',
          dateLaptop: 'cq-5xs:hidden',
          cifDesktop: 'hidden cq-lg:block',
          cifLaptop: 'cq-lg:hidden',
          actionsDesktop: 'hidden cq-xl:flex',
          actionsMenu: 'cq-xl:hidden',
          optionsMenu: 'cq-xl:hidden'
        }
      }

      return {
        ...base,
        ...(byVisibility[this.visibilityKey] || {})
      }
    },
    typeDate () {
      return this.currentFormat.type
    },
    formatDate () {
      return this.currentFormat.date
    },
    formatValueDate () {
      return this.currentFormat.valueDate
    },
    cifEmpresaOptions () {
      return this.cifEmpresaList.map((item) => ({
        id: item.IdCIFEmpresa,
        name: item.RazonSocial,
        value: item
      }))
    },
    activePeriods () {
      return this.$store.getters['config/ACTIVE_PERIODS']
    }
  },
  mounted: async function () {
    await this.getListaCifs()
    if (!this.cifEmpresa) {
      this.updateCifEmpresa(this.cifEmpresaList[0] || '', false)
    }

    if (!this.activePeriod) {
      this.toggleActivePeriod('mes', false)
    }
    
    if (!this.valueDate) {
      this.updateValueDate(this.optionalFormat(moment(), this.currentFormat.momentValueDate), false)
    }

    this.refreshPage()
    this.bindQuarterDropdownScroll()
  },
  unmounted () {
    this.unbindQuarterDropdownScroll()
  },
  methods: {
    reloadQuarters (quarterReference = this.valueDate, onLoaded = null) {
      if (this.loadingQuarters) return
      try {
        this.loadingQuarters = true
        this.$nextTick(() => {
          const quarterMoment = quarterReference ? moment(quarterReference, this.currentFormat.momentValueDate) : moment().startOf('quarter')
          const currentYear = quarterMoment.year()
          const now = moment()
          const nowYear = now.year()
          const nowQuarter = now.quarter()
          const yearOffsets = [-2, -1, 0, 1, 2]
          const quarters = [1, 2, 3, 4]

          // Generar todas las opciones de trimestres
          this.quarterOptions = yearOffsets
            .flatMap(yearOffset => {
              const year = currentYear + yearOffset
              return quarters.map(quarter => {
                const date = moment(year, 'YYYY').quarter(quarter).startOf('quarter')
                const isFutureQuarterInCurrentYear = year === nowYear && quarter > nowQuarter
                return {
                  id: date.format(this.currentFormat.momentValueDate),
                  name: date.format(this.currentFormat.momentDate),
                  value: date.format(this.currentFormat.momentValueDate),
                  disabled: isFutureQuarterInCurrentYear,
                  date
                }
              })
            })
            // Filtrar: no mostrar años posteriores al actual
            .filter(option => option.date.year() <= nowYear)
            // Remover la propiedad 'date' del resultado final
            .map(({ date, ...option }) => option)

          this.$nextTick(() => {
            this.loadingQuarters = false
            if (onLoaded) onLoaded()
          })
        })
      } catch (error) {
        this.loadingQuarters = false
      }
    },
    handleQuarterDropdownScroll (event) {
      if (this.loadingQuarters) return
      const el = event.target
      const epsilon = 2
      const prevScrollTop = this._quarterLastScrollTop ?? el.scrollTop
      const scrollingDown = el.scrollTop >= prevScrollTop
      const scrollingUp = el.scrollTop <= prevScrollTop
      this._quarterLastScrollTop = el.scrollTop

      const isAtBottom = (el.scrollHeight - (el.scrollTop + el.clientHeight)) <= epsilon
      const isAtTop = el.scrollTop <= epsilon

      const lastQuarterValue = this.quarterOptions.at(-1)?.value
      const lastQuarterMoment = lastQuarterValue
        ? moment(lastQuarterValue, this.currentFormat.momentValueDate).startOf('quarter')
        : null
      const currentQuarterMoment = moment().startOf('quarter')
      const canLoadDown = !!lastQuarterMoment && lastQuarterMoment.isBefore(currentQuarterMoment)

      const shouldReload = ((isAtBottom && scrollingDown && canLoadDown) || (isAtTop && scrollingUp))
      if (shouldReload) {
        const anchorIndex = isAtBottom ? -1 : 0
        const anchorName = this.quarterOptions.at(anchorIndex)?.name
        const anchorValue = this.quarterOptions.at(anchorIndex)?.value
        const block = isAtBottom ? 'end' : 'start'
 
        this.reloadQuarters(anchorValue, () => {
          const anchorItem = Array.from(el.querySelectorAll('.el-select-dropdown__item'))
            .find(item => item.textContent.trim() === anchorName)
          if (anchorItem) {
            this.$nextTick(() => (anchorItem.scrollIntoView({ block, inline: 'nearest', behavior: 'auto' })))
            this._quarterLastScrollTop = el.scrollTop
          }
        })
      }
    },
    bindQuarterDropdownScroll () {
      this.unbindQuarterDropdownScroll()

      const scrollElement = this.getVisibleQuarterDropdownScrollElement()
      if (!scrollElement) return

      this.quarterDropdownScrollElement = scrollElement
      this.quarterScrollListener = this.handleQuarterDropdownScroll.bind(this)
      this.quarterDropdownScrollElement.addEventListener('scroll', this.quarterScrollListener, { passive: true })
    },
    unbindQuarterDropdownScroll () {
      if (this.quarterDropdownScrollElement && this.quarterScrollListener) {
        this.quarterDropdownScrollElement.removeEventListener('scroll', this.quarterScrollListener)
        this.quarterDropdownScrollElement = null
        this.quarterScrollListener = null
      }
      this._quarterLastScrollTop = null
    },
    handleVisibleChangeQuarterDropdown (open) {
      this.reloadQuarters()
      if (open) {
        this.$nextTick(() => this.bindQuarterDropdownScroll())
        this.updateQuarterPickerElement()
      } else {
        this.unbindQuarterDropdownScroll()
        this.collapsedQuarterPickerElement = null
      }
    },
    getVisibleQuarterDropdownScrollElement () {
      const quarterPicker = this.$refs.quarterPicker || this.$refs.collapsedQuarterPicker
      const visibleDropdown = quarterPicker?.$refs?.select?.$refs?.popper?.$el

      return visibleDropdown?.querySelector('.el-scrollbar__wrap') || visibleDropdown?.querySelector('.el-select-dropdown__wrap')
    },
    optionalFormat (valueMoment, format) {
      return format ? valueMoment.format(format) : valueMoment.toDate() 
    },
    async getListaCifs () {
      try {
        this.$store.commit('setIsLoading', true)
        const data = await getAllCompanies(this.clientId !== -1 ? { idCliente: this.clientId } : {})
        if (data.blnError === true) {
          this.doFeedback(i18n.t('feedback.error.formated_api_response_error', data))
        } else {
          this.cifEmpresaList = data.CIFSEmpresa
        }
      } catch (error) {
      } finally {
        this.$store.commit('setIsLoading', false)
      }
    },
    toggleActivePeriod (period, refresh = true) {
      if (this.activePeriod !== period) {
        if (period !== 'trimestre') {
          this.unbindQuarterDropdownScroll()
        } else {
          this.bindQuarterDropdownScroll()
        }
        this.$store.dispatch('financialdashboard/setActivePeriod', period)
        this.$emit('change', { field: 'activePeriod', value: period, refresh })
      }
    },
    updateValueDate (valueDate, refresh = true) {
      if (typeof this.valueDate?.getTime === 'function' && typeof valueDate?.getTime === 'function' ? this.valueDate.getTime() !== valueDate.getTime() : this.valueDate !== valueDate) {
        this.$store.commit('financialdashboard/setValueDate', valueDate)
        this.$emit('change', { field: 'valueDate', value: valueDate, refresh })
      }
    },
    updateCifEmpresa (CIFEmpresa, refresh = true) {
      if (this.cifEmpresa.IdCIFEmpresa !== CIFEmpresa.IdCIFEmpresa) {
        this.$store.commit('financialdashboard/setCifEmpresa', CIFEmpresa)
        this.$emit('change', { field: 'cifEmpresa', value: CIFEmpresa, refresh })
      }
    },
    refreshPage () {
      this.$emit('refresh')
    },
    refreshPageFromMenu () {
      this.refreshPage()
      this.closeOptions()
    },
    printFinancialDashboard () {
      this.$emit('print')
    },
    printFinancialDashboardFromMenu () {
      this.printFinancialDashboard()
      this.closeOptions()
    },
    updateDatePickerElement () {
      this.$nextTick(() => {
        const picker = this.$refs.collapsedDatePicker
        this.collapsedPickerElement =
        picker?.picker?.$el || // interno de Element UI
        picker?.popperElm || // fallback común
        document.querySelector('.collapsed-date-picker-option') // fallback robusto
      })
    },
    updateQuarterPickerElement () {
      this.$nextTick(() => {
        const picker = this.$refs.collapsedQuarterPicker
        this.collapsedPickerElement =
        picker?.$refs?.select?.$refs?.popper?.$el || // interno de Element UI
        document.querySelector('.collapsed-quarter-picker-option') // fallback robusto
      })
    },
    updateCifEmpresaPickerElement () {
      this.$nextTick(() => {
        const picker = this.$refs.cifEmpresaLaptopPicker
        this.collapsedPickerElement =
        picker?.$refs?.select?.$refs?.popper?.$el || // interno de Element UI
        document.querySelector('.collapsed-cif-empresa-picker-option') // fallback robusto
      })
    },
    togglePeriodDropdown () {
      this.showPeriodDropdown = !this.showPeriodDropdown
    },
    closePeriodDropdown () {
      this.showPeriodDropdown = false
    },
    togglePeriodDropdownMobile () {
      this.showPeriodDropdownMobile = !this.showPeriodDropdownMobile
    },
    closePeriodDropdownMobile () {
      this.showPeriodDropdownMobile = false
    },
    toggleOptions () {
      this.showOptions = !this.showOptions
    },
    closeOptions () {
      this.showOptions = false
      this.collapsedPickerElement = null
    }
  }
}
</script>
<style scoped>
.\!bg-primary-50 {
    background-color: var(--primary-50) !important;
}
.dark .dark\:\!bg-darkblue {
    background-color: var(--darkblue-DEFAULT) !important;
}
.active{
  @apply bg-primary-600 text-secondary-50 !important;
}
.active:hover, .active:focus{
 @apply bg-primary-300 !important;
}
</style>
<style lang="scss" scoped>
.el-date-editor::v-deep {
  &.el-input {
    width: unset;
    min-width: 10.5rem;
  }
  .el-input__inner {
    width: 100%;
  }
}
.accessible-el-select::v-deep .el-input {
  min-width: 9.6rem;
}

.el-date-editor::v-deep .el-date-picker {
  position: absolute;
}
</style>
